import { TaskManagerType } from '@prisma/client';
import { api, skipBatchOption } from '~/utils/api';
import { serverError } from '~/utils/serverError';

export const HOME_QUEUE_OVERVIEW_INPUT = {
  type: TaskManagerType.MARKETING,
  weeks: 13,
  recentLimit: 8,
} as const;

export function useHomeQueueOverview(enabled: boolean) {
  return api.task.getHomeQueueOverview.useQuery(HOME_QUEUE_OVERVIEW_INPUT, {
    ...skipBatchOption,
    enabled,
    onError: serverError,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
